import { useMemo } from 'react';
import { DetailedIconEmail } from '@zillow/constellation';
import { Paragraph } from '@zillow/constellation-10';

import ScreeningPreferencesTextButton from '../../../ScreeningPreferencesTextButton';

import {
  StyledEmptyIconContainer,
  StyledEmptySimpleCard,
  StyledEmptyStateContainer,
} from '../../../../StyledComponents';
import { EmptyStateBodyText, EmptyStateTitleText } from '../../../../styles';

type Props = {
  showScreeningCriteriaCTA?: boolean;
  isScreeningCriteriaSet?: boolean;
  screeningCriteriaPath?: string;
};

const EmptyInquiriesCard = ({ showScreeningCriteriaCTA, isScreeningCriteriaSet, screeningCriteriaPath }: Props) => {
  const renderBodyContent = useMemo(() => {
    return showScreeningCriteriaCTA ? (
      <>
        <Paragraph css={{ marginBottom: '600' }}>
          When a renter contacts you, help make a good first impression by responding within 24 hours. While you wait,
          get ready to attract the right renters for you.
        </Paragraph>

        <Paragraph textStyle="body-sm">
          <ScreeningPreferencesTextButton />
        </Paragraph>
      </>
    ) : (
      `When a renter contacts you, try to respond within 24 hours. Replying to every inquiry as quickly as you can
      will help give renters a good impression of you and create a better experience for Zillow users.`
    );
  }, [showScreeningCriteriaCTA]);

  return (
    <StyledEmptySimpleCard
      data-testid="EmptyInquiriesCard"
      marginBottom={2}
      cardElevation={0}
      paddingX={'md'}
      paddingY={5}
    >
      <StyledEmptyStateContainer data-testid="EmptyStateContainer">
        <StyledEmptyIconContainer>
          <DetailedIconEmail />
        </StyledEmptyIconContainer>

        <EmptyStateTitleText asChild>
          <h4>No inquiries yet</h4>
        </EmptyStateTitleText>

        <EmptyStateBodyText asChild>
          <p>{renderBodyContent}</p>
        </EmptyStateBodyText>
      </StyledEmptyStateContainer>
    </StyledEmptySimpleCard>
  );
};

export default EmptyInquiriesCard;
